import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Camera, Search, Check, Sparkles } from "lucide-react";

const COPY = {
  pic_out: {
    Icon: Camera, title: "You're out of free card scans",
    body: "You've used all 5 free Pic-to-Lead scans this month. Go unlimited and keep turning every card into a CRM contact.",
    plan: "Basic · $97/mo", perks: ["Unlimited card scans", "Snap cards at events on your phone", "Contacts sent straight to your CRM"],
  },
  pic_last: {
    Icon: Camera, title: "That was your last free card scan",
    body: "Nice work! You've used all 5 free scans for this month. Upgrade now so the next card at your event isn't left behind.",
    plan: "Basic · $97/mo", perks: ["Unlimited card scans", "Snap cards at events on your phone", "Contacts sent straight to your CRM"],
  },
  discover_out: {
    Icon: Search, title: "Your Discover trial has ended",
    body: "You've used both free Discover scans. Upgrade to keep finding decision-makers and filling your pipeline.",
    plan: "Starter · $199/mo", perks: ["Discover + Advanced Search", "100 verified leads every month", "My Leads, New Businesses & Scan History"],
  },
  discover_last: {
    Icon: Search, title: "That was your last free Discover scan",
    body: "Your scan is running and the leads will land in your CRM. Upgrade to keep discovering new leads anytime.",
    plan: "Starter · $199/mo", perks: ["Discover + Advanced Search", "100 verified leads every month", "My Leads, New Businesses & Scan History"],
  },
};

let setKindGlobal = null;
let currentKind = null;

export const openUpgrade = (kind) => {
  if (!setKindGlobal) return;
  if (currentKind && currentKind.endsWith("_last") && kind.endsWith("_out")) return;
  currentKind = kind;
  setKindGlobal(kind);
};

export const UpgradeDialogHost = () => {
  const [kind, setKind] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setKindGlobal = setKind;
    return () => { setKindGlobal = null; };
  }, []);

  const close = () => { currentKind = null; setKind(null); };
  const copy = COPY[kind];

  return (
    <Dialog open={!!copy} onOpenChange={(o) => !o && close()}>
      {copy && (
        <DialogContent data-testid={`upgrade-dialog-${kind}`} className="sm:max-w-md">
          <DialogHeader>
            <div style={{ width: 56, height: 56, borderRadius: 16, background: "linear-gradient(135deg,#dbeafe,#ede9fe)", display: "grid", placeItems: "center", margin: "0 auto 8px" }}>
              <copy.Icon size={26} color="#4f46e5" />
            </div>
            <DialogTitle style={{ textAlign: "center", fontSize: 20 }}>{copy.title}</DialogTitle>
            <DialogDescription style={{ textAlign: "center" }}>{copy.body}</DialogDescription>
          </DialogHeader>
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16 }}>
            <div style={{ fontWeight: 700, color: "#1e293b", marginBottom: 8 }} data-testid="upgrade-dialog-plan">{copy.plan}</div>
            {copy.perks.map((p) => (
              <div key={p} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 14, color: "#334155", marginTop: 6 }}>
                <Check size={16} color="#16a34a" /> {p}
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
            <Button variant="outline" onClick={close} data-testid="upgrade-dialog-later-btn">Maybe later</Button>
            <Button onClick={() => { close(); navigate("/plans"); }} data-testid="upgrade-dialog-upgrade-btn">
              <Sparkles size={16} style={{ marginRight: 8 }} /> See plans & upgrade
            </Button>
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
};
